import { bottomNavigationActionClasses } from "@mui/material/BottomNavigationAction";
import { typographyResponsive } from "../../styles/utils/typography.module";
import { transition } from "../../styles/utils/utils";
export const MuiBottomNavigationActionTheme = (dt) => {
    return {
        defaultProps: {},
        styleOverrides: {
            root: {
                gap: dt.stacked.xSmall,
                transition: transition("background"),
                minWidth: "64px",
                padding: "12px 8px 16px 8px",
                color: dt.color.onSurface.key,
                ".PixelIcon": {
                    margin: "4px 8px",
                    '&:not([class*="MuiSvgIcon-color"])': {
                        backgroundColor: dt.color.onSurface.variant,
                    },
                },
                [`.${bottomNavigationActionClasses.label}[class]`]: Object.assign(Object.assign({}, typographyResponsive(dt, "caption")), { color: dt.color.onSurface.variant }),
                "&:hover": {
                    background: dt.cta.outlined.color.background.primary.hover,
                    transition: transition("background"),
                },
                "&:focus-visible": {
                    background: dt.cta.outlined.color.background.primary.focus,
                    boxShadow: dt.state.focus.primary,
                    transition: transition("background", "hover"),
                },
                [`&.${bottomNavigationActionClasses.selected}`]: {
                    [`.${bottomNavigationActionClasses.label}[class]`]: {
                        color: dt.color.onSurface.key,
                    },
                    ".PixelIcon": {
                        backgroundColor: dt.color.primary.key,
                    },
                },
                ".Pxl-BottomNavigation-secondaryOnSurfaceKey &": {
                    "&:hover": {
                        background: dt.cta.outlined.color.background.secondary.hover,
                    },
                    "&:focus-visible": {
                        background: dt.cta.outlined.color.background.secondary.focus,
                        boxShadow: dt.state.focus.secondary,
                    },
                    [`&.${bottomNavigationActionClasses.selected}`]: {
                        ".PixelIcon": {
                            backgroundColor: dt.color.secondary.key,
                        },
                    },
                },
                ".Pxl-BottomNavigation-invertedOnPrimary &": {
                    opacity: dt.opacity[90],
                    color: dt.color.inverseOnSurface,
                    [`.${bottomNavigationActionClasses.label}[class]`]: {
                        color: dt.color.inverseOnSurface,
                    },
                    "&:hover": {
                        background: dt.cta.outlined.color.background.inverted.hover,
                    },
                    "&:focus-visible": {
                        background: dt.cta.outlined.color.background.inverted.focus,
                        boxShadow: dt.state.focus.neutralInverted,
                    },
                    ".PixelIcon": {
                        backgroundColor: dt.color.inverseOnSurface,
                    },
                    [`&.${bottomNavigationActionClasses.selected}`]: {
                        color: dt.cta.outlined.color.border.inverted.default,
                        opacity: "unset",
                        ".PixelIcon": {
                            backgroundColor: dt.cta.outlined.color.text.inverted.default,
                        },
                    },
                },
            },
        },
    };
};
